import { HTTPMethod } from '../../../app/types'
import LuruAPIRequest, { LuruAPIRequestOptions } from '../../LuruAPIRequest'
import { FetchTaskParameter } from '../middleware/fetchTask'

export const fetchTask = ({ taskId: task_id }: Readonly<FetchTaskParameter>, options: LuruAPIRequestOptions) => {
  var request = new LuruAPIRequest('/api/tasks/' + task_id, HTTPMethod.GET, options)
  return request.make()
}
